import { render, staticRenderFns } from "./client-matter-data.vue?vue&type=template&id=3b767750&"
import script from "./client-matter-data.vue?vue&type=script&lang=ts&"
export * from "./client-matter-data.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports